/**
 * The brand's own website as the starting URL for a new Square Online or
 * WooCommerce source — the counterpart of the Shopify source's `storeUrl`
 * prefill. A single-brand shop's home page is exactly the "import the whole
 * shop" URL those adapters take, so for the common case the curator only has
 * to click Test.
 *
 * Both adapters require `https://`, so a bare domain gets the scheme and an
 * `http://` address is upgraded (shops serve https; the importer refuses http).
 * Trailing slashes are trimmed, as for Shopify. No website → empty string, and
 * the field simply stays blank.
 */
export function prefillShopUrl(mainWebsite: string | undefined | null): string {
  const raw = (mainWebsite ?? '').trim();
  if (!raw) return '';
  const withScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(raw) ? raw : `https://${raw}`;
  return withScheme.replace(/^http:\/\//i, 'https://').replace(/\/+$/, '');
}
